//
//
//
//
//
//
//

import alphabet from '../components/Alphabet-Trainer'

export default {
  components: {
    alphabet,
  },
  data: () => ({
    loaded: false,
    ids: [],
  }),
  created() {
    this.loadVocab()
  },
  methods: {
    loadVocab() {
      this.donzo()
    },
    async donzo() {
      const { rows } = await this.$bucket.db.allDocs({
        startkey: `letter:`,
        endkey: `letter:\uffff`,
      })
      this.start(rows.map(row => row.id))
      this.loaded = true
    },
    start(ids) {
      this.ids.push(...this.shuffle(ids))
      this.selecting = false
      this.loaded = true
    },
    shuffle(array) {
      let currentIndex = array.length,
        randomIndex
      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex--
        ;[array[currentIndex], array[randomIndex]] = [
          array[randomIndex],
          array[currentIndex],
        ]
      }

      return array
    },
  },
}
